const keys = {
  ENTER: "Enter",
  DOT: ".",
};

export default keys;
